import { z } from 'zod';
import { servicesProviderPricingCodeOnlySchema, servicesProviderPricingCodeOnlyDtoSchema } from '../ServicesProviderPricing.js';
import { serviceConfigSchema } from './SharedServiceConfig.js';

/**
 * This is the service that handles the payout for the coverage tax to the tax service (whoever we pay sales tax to)
 * We collect the tax for the coverage and then pay it to the tax service (same as the external_tax service on the deal)
 * @example Payout breakdown:
 * - Coverage retail cost: $100
 * - Coverage markup: $10 (40% Ekho, 60% Dealer)
 * - Coverage tax: $5
 * - Coverage payout to tax service (coverage_tax): $5
 */
// ============================================================================
// Pricing Schemas
// ============================================================================
const coverageTaxServicePricingSchema = servicesProviderPricingCodeOnlySchema;
const coverageTaxServicePricingDtoSchema = servicesProviderPricingCodeOnlyDtoSchema;
// ============================================================================
// Core Schema
// ============================================================================
const coverageTaxServiceConfigSchema = serviceConfigSchema.extend({
    pricing: z.array(coverageTaxServicePricingSchema),
});
// ============================================================================
// DTO Schema
// ============================================================================
const coverageTaxServiceConfigDtoSchema = serviceConfigSchema.extend({
    pricing: z.array(coverageTaxServicePricingDtoSchema),
});

export { coverageTaxServiceConfigDtoSchema, coverageTaxServiceConfigSchema, coverageTaxServicePricingDtoSchema, coverageTaxServicePricingSchema };
//# sourceMappingURL=CoverageTaxServiceConfig.js.map
